module.exports = __webpack_public_path__ + "img/video-connectivy-4.b0847e11.png";